// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 90px;

  > svg {
    position: absolute;
    top: 325px;
    left: -20px;

    &:nth-child(2) {
      top: unset;
      left: unset;
      bottom: -375px;
      right: -20px;
      transform: rotate(180deg);
    }
  }

  h1 {
    background: linear-gradient(151deg, #01b6f9 0%, #1d529b 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: SF Pro Display;
    font-size: 120px;
    font-style: normal;
    font-weight: 400;
    line-height: 106.8%; /* 128.16px */
    letter-spacing: -6px;
    margin-bottom: 50px;
    height: 270px;
  }

  @media (max-width: 992px) {
    h1 {
      font-size: 100px;
      font-style: normal;
      font-weight: 400;
      line-height: 93%;
      letter-spacing: -5px;
      height: 100%;
      padding-bottom: 10px;

      &:nth-child(1) {
        background: linear-gradient(151deg, #c674c9 0%, #943cea 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 50px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
  }
`;

export const Row = styled.div`
  position: relative;

  &:nth-child(1) {
    grid-area: 1 / 1 / 2 / 2;
  }
  &:nth-child(2) {
    grid-area: 1 / 2 / 2 / 3;
  }
  &:nth-child(3) {
    grid-area: 2 / 1 / 3 / 2;
  }
  &:nth-child(4) {
    grid-area: 2 / 2 / 3 / 3;

    > svg {
      position: absolute;
      top: -5px;
      left: -120px;

      width: 246.937px;
      height: 285.594px;
      transform: rotate(-17.209deg);
    }

    .space {
      width: 100%;
      height: 100%;
      /* padding-left: 20px; */
    }

    .inside {
      width: 380px;
      height: 240px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      > div {
        margin-left: -80px;

        p {
          margin-top: 10px;
        }
      }
    }
  }

  span {
    color: #fff;
    font-family: SF Pro Display;
    font-size: 16px;
    font-weight: 400;
    /* letter-spacing: -0.387px; */
    opacity: 0.3;
  }

  h2 {
    font-family: SF Pro Display;
    font-size: 90px;
    font-weight: 700;
    letter-spacing: -4.949px;
    background: linear-gradient(146deg, #01b6f9 0%, #1e529b 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    color: rgba(255, 255, 255, 0.56);
    font-family: 'SF Pro Display';
    font-size: 22px;
    font-weight: 300;
    opacity: 0.9;

    strong {
      background: linear-gradient(127deg, #01b6f9 0%, #1d529b 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 400;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);

    .mobile-row {
      display: flex;

      img {
        width: 178px;
        height: 208.769px;

        &:nth-child(1) {
          margin-left: -20px;
        }
        &:nth-child(2) {
          margin-right: -20px;
        }
      }
    }

    p {
      font-size: 20px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
    }

    &:nth-child(1) {
      grid-area: 1 / 1 / 2 / 2;
    }

    &:nth-child(2) {
      grid-area: 2 / 1 / 3 / 2;

      strong {
        white-space: nowrap;
      }
    }

    &:nth-child(3) {
      grid-area: 3 / 1 / 4 / 2;

      p {
        font-size: 18px;
      }
    }

    &:nth-child(4) {
      grid-area: 4 / 1 / 5 / 2;

      .space {
        position: relative;
        margin-left: calc(100% - 74%);

        img {
          position: absolute;
          right: 62px;
          top: -10px;
          transform: scale(0.6);
        }
      }
    }
  }
`;
